export default __webpack_public_path__ + "static/media/2431.763319a5.png";